import React, { useEffect, useState } from "react";
import {
  Container,
  Spinner,
  Row,
  Col,
  UncontrolledTooltip,
  Modal,
  Input,
  Label,
  FormGroup,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import Button from "components/Inputs/TButton";
import Client from "../../../../services/WebAPI";
import { useDispatch } from "react-redux";
import { alertActions } from "redux/_actions";
import AlertMessage from "components/Alert";
const { SearchBar } = Search;

const PopConfirm = ({ onOk }) => {
  const [modal, SetModal] = useState(false);

  const handleConfirm = () => {
    if (onOk) onOk();
    SetModal(false);
  };

  return (
    <>
      <Button onClick={() => SetModal(!modal)} color="danger">
        <i className="far fa-trash-alt" />
      </Button>
      <Modal isOpen={modal} toggle={() => SetModal(false)}>
        <ModalHeader
          className="confirm-modal-header"
          toggle={() => SetModal(false)}
        >
          Are you sure to delete this Tier?
        </ModalHeader>
        <ModalBody className="confirm-modal-body">
          As a result of this action, this tier will be deleted from the system.
        </ModalBody>
        <ModalFooter className="confirm-modal-footer">
          <Button color="danger" size="sm" onClick={handleConfirm}>
            <i className="far fa-trash-alt" style={{ marginRight: 5 }} />
            Continue
          </Button>{" "}
          <Button size="sm" outline onClick={() => SetModal(false)}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default function Tier() {
  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tierData, setTierData] = useState({
    tier: null,
    price: null,
    productId: "",
  });
  const [addTier, setAddTier] = useState(false);

  const dispatch = useDispatch();
  useEffect(() => {
    fetchTier();
  }, []);

  const fetchTier = async () => {
    setLoading(true);
    try {
      const resp = await Client.get("/Billing/BillingTiers");
      if (resp.data.status && resp.data.result) setRowData(resp.data.result);
    } catch (err) {
      console.log("err", err);
    }
    setLoading(false);
  };

  const addTierSubmit = async () => {
    try {
      const { tier, productId, price } = tierData;
      if (!tier || !productId || !price) {
        dispatch(alertActions.error("Field Missing!"));
        setTimeout(() => {
          dispatch(alertActions.clear());
        }, 2500);
        return;
      }
      const req = {
        Tier: parseInt(tier),
        ProductID: productId,
        Price: parseFloat(price),
      };
      const resp = await Client.post("/Billing/AddBillingTier", req);
      if (resp.data.status) {
        fetchTier();
        setAddTier(false);
        setTierData({
          tier: null,
          price: null,
          productId: "",
        });
        dispatch(alertActions.success("Added new tier"));
        setTimeout(() => {
          dispatch(alertActions.clear());
        }, 2500);
      }
    } catch (err) {
      console.log("err", err);
      dispatch(alertActions.error("Something went wrong"));
      setTimeout(() => {
        dispatch(alertActions.clear());
      }, 2500);
    }
  };

  const deleteTier = async (id) => {
    try {
      const resp = await Client.delete(`/Billing/DeleteBillingTiers?id=${id}`);
      if (resp.data.status) {
        fetchTier();
        dispatch(alertActions.success("Tier Deleted!"));
        setTimeout(() => {
          dispatch(alertActions.clear());
        }, 2500);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleData = (i, val) => {
    const data = { ...tierData };
    data[i] = val;
    setTierData(data);
  };

  const columns = [
    {
      dataField: "Tier",
      text: "Tier",
      sort: true,
      searchable: true,
    },
    {
      dataField: "Price",
      text: "Price",
      sort: true,
      classes: "common-table-column-style",
      searchable: true,
      formatter: (cell, row) => <span>${cell}</span>,
    },
    {
      dataField: "ProductID",
      text: "Product ID",
      sort: true,
      classes: "common-table-column-style",
      searchable: true,
    },
    {
      text: "Actions",
      classes: "common-table-column-style",
      searchable: true,
      formatter: (cell, row) => (
        <span>
          <PopConfirm onOk={() => deleteTier(row.Id)} />
        </span>
      ),
    },
  ];

  const paginationOptions = {
    custom: true,
    withFirstAndLast: true,
    totalSize: rowData.length,
  };
  return (
    <div>
      <Container fluid>
        {!addTier && <AlertMessage />}
        <Row>
          <div className="col">
            <ToolkitProvider
              keyField="PartnerId"
              data={rowData}
              columns={columns}
              search
            >
              {(props) => (
                <PaginationProvider
                  pagination={paginationFactory(paginationOptions)}
                >
                  {({ paginationProps, paginationTableProps }) => (
                    <div>
                      <Row style={{ marginBottom: 6 }}>
                        <Col
                          xs="5"
                          className="local-text"
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          Entries per page :
                          <SizePerPageDropdownStandalone
                            className="common-page-size-selector ml-2"
                            {...paginationProps}
                          />
                        </Col>
                        <Col className="d-flex justify-content-end">
                          <UncontrolledTooltip target={"tier"}>
                            Add Tier
                          </UncontrolledTooltip>
                          <Button
                            id="tier"
                            color="primary"
                            outline
                            onClick={() => setAddTier(true)}
                          >
                            +
                          </Button>
                          <SearchBar
                            className="table-search-input"
                            {...props.searchProps}
                          />
                        </Col>
                      </Row>
                      <BootstrapTable
                        hover
                        bordered={false}
                        //rowEvents={rowEvents}
                        noDataIndication={
                          loading ? (
                            <Spinner type="grow" color="primary" />
                          ) : (
                            "No Data"
                          )
                        }
                        headerWrapperClasses="table-header-light"
                        bodyClasses="clickable-table-row"
                        {...props.baseProps}
                        {...paginationTableProps}
                      />
                      <Row style={{ marginTop: 10 }}>
                        <Col>
                          <PaginationTotalStandalone {...paginationProps} />
                        </Col>
                        <Col>
                          <PaginationListStandalone {...paginationProps} />
                        </Col>
                      </Row>
                    </div>
                  )}
                </PaginationProvider>
              )}
            </ToolkitProvider>
          </div>
        </Row>
        <Modal
          isOpen={addTier}
          toggle={() => {
            setAddTier(false);
            setTierData({
              tier: null,
              price: null,
              productId: "",
            });
          }}
        >
          <ModalHeader>Add Tier</ModalHeader>
          <AlertMessage />
          <ModalBody className="confirm-modal-body">
            <FormGroup>
              <Label for="tier">Tier :</Label>
              <Input
                id="tier"
                value={tierData?.tier}
                onChange={(e) => handleData("tier", e.target.value)}
                type="number"
              />
            </FormGroup>
            <FormGroup>
              <Label for="price">Price :</Label>
              <Input
                id="price"
                value={tierData?.price}
                onChange={(e) => handleData("price", e.target.value)}
                type="number"
              />
            </FormGroup>
            <FormGroup>
              <Label for="productId">Product ID :</Label>
              <Input
                id="tiproductIder"
                value={tierData?.productId}
                onChange={(e) => handleData("productId", e.target.value)}
                type="text"
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter className="confirm-modal-footer">
            <Button color="primary" size="sm" onClick={addTierSubmit}>
              <i className="fas fa-save" style={{ marginRight: 5 }} />
              Add
            </Button>
            <Button
              size="sm"
              outline
              onClick={() => {
                setAddTier(false);
                setTierData({
                  tier: null,
                  price: null,
                  productId: "",
                });
              }}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </Container>
    </div>
  );
}
